import { useState } from 'react'
import { useStore } from 'react-redux'

import { updateUserNotesFailed, updateUserNotesSucceeded } from '../actions/orders/patch'
import Remote from '../remote'


const useUpdateUserNotes = () => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [failed, setFailed] = useState(false)
  const store = useStore()

  const executeRequest = (orderId, userNotes) => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)

    Remote.updateOrder(orderId, { userNotes }).then((result) => {
      store.dispatch(updateUserNotesSucceeded(result))
      setLoading(false)
      setSuccess(true)
    }).catch((err) => {
      store.dispatch(updateUserNotesFailed(err))
      setLoading(false)
      setFailed(true)
    })
  }

  return [executeRequest, { loading, success, failed }]
}

export default useUpdateUserNotes
